import React from 'react';
import { TextArea } from '@makemydeal/dr-ui-bricks-components';
import { NotesSectionContainer } from './NotesSection.styles';
import type { NotesSectionProps } from '../../types';

const NotesSection: React.FC<NotesSectionProps> = ({ notes, onChange }) => {
    return (
        <NotesSectionContainer>
            <TextArea
                name="request-proposal-notes"
                label="Notes for Manager (Optional)"
                value={notes}
                onChange={(e: any) => onChange(e.target.value)}
                inputId="request-proposal-notes"
                data-testid="request-proposal-notes"
                rows={10}
            />
        </NotesSectionContainer>
    );
};

export default NotesSection;
